<template>
    <div class="quick-buys quick-buys-alt">
        
        <div class="quick-buys-item" v-for="product in products" v-on:click="goToProduct(product.permalink+'?redirect_url='+backtoUrl)">
            <figure>
                <img loading="lazy" :src="product.thumbnail" :srcset="`${product.thumbnail} 1x, ${product.thumbnail_ret} 2x`" :alt="product.post_title" />
            </figure>
            <div class="quick-buys-item-content">
                <div class="quick-buys-item-title">
                    <a :href="product.permalink+'?redirect_url='+backtoUrl">{{ product.post_title }}</a>
                </div>
                <div class="quick-buys-item-footer">
                    <div class="quick-buys-item-price" v-if="product.isSale">
                        <span class="price--old">{{ product.price.oldPrice }}</span>
                        <span class="price--new">{{ product.price.regularPrice }}</span>
                    </div>
                    <div class="quick-buys-item-price h2" v-if="! product.isSale">
                        <span class="price">{{ product.price.regularPrice }}</span>
                    </div>
                    <div class="quick-buys-add" v-on:click.stop.prevent="showProduct(product)">+</div>
                </div>
            </div>
        </div>

        <transition name="quick-buys-fade">
            <div class="quick-buys-overlay" v-show="is_open" v-on:click.self="close">
                <transition name="quick-buys-slide">
                    <div class="quick-buys-body" v-show="is_open">
                        <div class="container">
                            <div class="quick-buys-content">
                                <x class="quick-buys-close" @close="close"></x>

                                <div class="quick-buys-slider" :class="{'quick-buys-slider-one': (sliderImageCount == 1)}">
                                    <div ref="carousel" class="swiper-container">
                                        <div class="swiper-wrapper">
                                            <img class="swiper-slide" loading="lazy" v-for="sliderImage in product.sliderImages" :src="sliderImage.gallery" :alt="sliderImage.title" />    
                                        </div>
                                        <div class="swiper-button-prev swiper-button quickbuy-slider-button"></div>
                                        <div class="swiper-button-next swiper-button quickbuy-slider-button"></div>
                                    </div>
                                </div>

                                <div class="quick-buys-product">
                                    <div class="quick-buys-title-wrapper">
                                        <div class="quick-buys-title">{{ product.post_title }}</div>

                                        <div class="quick-buys-price d-block d-md-none" v-if="product.isSale">
                                            <span class="price--old">{{ product.price.oldPrice }}</span>
                                            <span class="price--new">{{ product.price.regularPrice }}</span>
                                        </div>
                                        <div class="quick-buys-price d-block d-md-none h2" v-if="! product.isSale">
                                            <span class="price">{{ product.price.regularPrice }}</span>
                                        </div>
                                    </div>

                                    <p>{{ product.post_excerpt }}</p>

                                    <div class="quick-buys-price d-none d-md-block" v-if="product.isSale">
                                        <span class="price--old">{{ product.price.oldPrice }}</span>
                                        <span class="price--new">{{ product.price.regularPrice }}</span>
                                    </div>
                                    <div class="quick-buys-price d-none d-md-block h2" v-if="! product.isSale">
                                        <span class="price">{{ product.price.regularPrice }}</span>
                                    </div>

                                    <div class="quick-buys-cta" :class="{'quick-buys-out_of_stock' : ! inStock}">
                                        <div class="container quick-buys-cta-container">
                                            <div class="row col-margin-5px">
                                                <div class="col-6" v-show="hasVariations()">
                                                    <select
                                                        :id="getAttributeKeyString()"
                                                        class=""
                                                        :name="variationAttributeKey"
                                                        :data-attribute_name="variationAttributeKey"
                                                        data-show_option_none="yes"
                                                        v-on:change="changeVariation($event)"
                                                        :data-variation="variationAttribute"
                                                    >
                                                        <option value="" :selected="variationKey == 0">{{ getAttributeKeyStringStudly() }}</option>
                                                        <option :value="getAttributeString(option.attributes)" v-for="(option, index) in product.variations" :selected="variationKey == (index + 1)">{{ getAttributeString(option.attributes) }}</option>
                                                    </select>
                                                </div>
                                                <div :class="{'col-6': hasVariations(), 'col-12': ! hasVariations()}">
                                                    <div class="product-single__order-button">

                                                        <button
                                                            data-quantity="1"
                                                            name="add-to-cart"
                                                            :data-product_id="product.ID"
                                                            :value="product.ID"
                                                            :data-product_sku="getSku(variation)"
                                                            :data-variation_id="variation.variation_id"
                                                            :data-variation="variationAttribute"
                                                            :data-product_title="hasVariations() ? variation.title : product.post_title" 
                                                            :data-product_price="hasVariations() ? variation.display_price : product.displayPrice" 
                                                            :data-product_category="product.category_name"
                                                            data-button_text="<span>In </span>winkelmand"
                                                            type="button"
                                                            class="btn-icon-shop btn btn-primary add_to_cart_button"
                                                            :class="{
                                                                ajax_add_to_cart: ! hasVariations(),
                                                                product_type_simple: ! hasVariations(),
                                                                product_type_variable: hasVariations()
                                                            }"
                                                            v-show="canOrder">
                                                        <span>In </span>winkelmand</button>

                                                        <input v-if="hasVariations()" type="hidden" name="add-to-cart" :value="product.ID">
                                                        <input v-if="hasVariations()" type="hidden" name="product_id" :value="product.ID">
                                                        <input v-if="hasVariations()" type="hidden" name="variation_id" class="variation_id" :value="variation.variation_id">
                                                    </div>
                                                    <div class="single_variation_wrap--choose quick-buys-red quick-buys-bold" v-show="! inStock">
                                                        Dit product is tijdelijk niet op voorraad
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>

    </div>
</template>

<script>

// VueAwesomeSwiper setup https://www.npmjs.com/package/vue-awesome-swiper
import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api'
import Swiper, { Navigation, Pagination } from '../../../../../../plugins/wpg-mindstyle-core/node_modules/swiper';


Vue.component('x', require('./X.vue').default);
Vue.use(VueCompositionApi)

export default {
    props: {
        baseUrl: {
            type: String,
            default: '',
        },
        imageUrl: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        products: {
            type: Array,
            default: () => [],
        },
        backtoUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            is_open: false,
            product: {
                image: '',
                post_title: '',
                post_excerpt: '',
                isSale: false,
                price: {
                    oldPrice: '',
                    regularPrice: '',
                }
            },
            variationKey: '',
            variation: {}, // filled from mounted
            variationAttribute: '',
            variationAttributeKey: '',
            variationKeyLowestPrice: '',
            sliderImageCount: 0, // we need to trigger an update when the amount changes
            inStock: false, // is it in stock or not
            canOrder: false, // can I order it or not
        }
    },
    components: { Swiper },
    /*directives: {
        swiper: directive
    },*/
    methods: {
        image(path) {
            return this.imageUrl+path;
        },

        url(path) {
            return this.baseUrl+'/'+path;
        },

        open() {
            $('body').addClass('quick-buys-open');
            this.is_open = true;
        },

        close() {
            $('body').removeClass('quick-buys-open');
            this.is_open = false;
        },

        /**
         * Go to a product permalink
         * @param  {string} permalink The permalink you want to go to
         * @return {void}
         */
        goToProduct(permalink) {
            window.location.href = permalink;
        },

        /**
         * Load a product into the popup and show it
         * @param  {object} product The product you want to show
         * @return {void}
         */
        showProduct(product) {
            if(product != this.product) {
                this.product = product;
                this.countImages();
            }
            this.loadVariationData(product);
            $(document.body).trigger('bind_add_to_cart_button');
            this.open();
        },

        /**
         * Load a new variation as currently chosen
         * @param  {event} event The event from the select onChange
         * @return {void}
         */
        changeVariation(event) {
            this.inStock = false;
            this.canOrder = false;

            this.variation = this.findVariationByAttribute(event.target.value);

            if(this.isInStock(this.variation) && event.target.value) {
                this.canOrder = true; // yes, we can order
                this.inStock = true; // don't show the out of stock message
                this.variationAttribute = this.getAttribute(this.variation);
                this.variationAttributeKey = Object.keys(this.variation.attributes)[0];
            }
            else if(! event.target.value) {
                this.inStock = true; // don't show the out of stock message, but we can't order
            }

            this.$forceUpdate();

            this.$nextTick(() => {
                $(document.body).trigger('bind_add_to_cart_button');
            });
        },

        /**
         * Initial loading of all the variations and setting the first
         * @param  {object} product The currently chosen product from the overview
         * @return {void}
         */
        loadVariationData(product) {
            let lowestPrice = 9999999; // set to impossible amount so we can check for lowest

            this.canOrder = false;
            this.inStock = false;

            $.each(product.variations, (index, variation) => {
                // check if this item has the lowest price of all variations when its in stock
                if(this.isInStock(variation) && variation.display_price > 0 && variation.display_price < lowestPrice) {
                    lowestPrice = variation.display_price;
                    this.variation = variation;
                    this.variationKey = index + 1;
                    this.canOrder = true;
                    this.inStock = true;
                    this.variationAttribute = this.getAttribute(this.variation);
                    this.variationAttributeKey = Object.keys(this.variation.attributes)[0];
                }
            });

            // if no article was found, select the first
            if(lowestPrice == 9999999) {
                this.variationKey = 0;

                // reset variation
                this.resetVariation();
            }

            // make the exception for single products
            if(! product.variations.length) {
                if(product.is_in_stock) {
                    this.canOrder = true;
                    this.inStock = true;
                }
            }

            this.$nextTick(() => {
                $(document.body).trigger('bind_add_to_cart_button');
            });
        },

        /**
         * Loop through the variations of the chosen product to find
         * the variation that matches the attribute we are looking for
         * @param  {string} attribute needle
         * @return {object}           Empty or the variation that matches (should always match)
         */
        findVariationByAttribute(attribute) {
            let neededVariation = {};
            $.each(this.product.variations, (index, variation) => {
                if(this.getAttributeString(variation.attributes) == attribute) {
                    neededVariation = variation;
                    return false;
                }
            });
            return neededVariation;
        },

        /**
         * Check to see if the current product has any variations
         * If not, its a single product
         * @return {Boolean}
         */
        hasVariations() {
            if(this.product.variations && this.product.variations.length) {
                return true;
            }
            return false;
        },

        /**
         * Check to see if the current product has any variations
         * If not, its a single product
         * @return {Boolean}
         */
        countImages() {
            if(this.product.sliderImages && this.product.sliderImages.length) {
                this.sliderImageCount = this.product.sliderImages.length;
            }
            else {
                this.sliderImageCount = 0;
            }
        },

        /**
         * Reset the variation with default values to not trigger errors
         * @return {void}
         */
        resetVariation() {
            this.variation = {
                variation_id: null,
                sku: null,
                attributes: {}
            };
        },

        /**
         * Get the complete first availible attribute object
         * @param  {object} variation The data of the variation you want to retrieve
         * @return {mixed}           Either json string or null
         */
        getAttribute(variation) {
            if(variation.attributes) {
                let firstAttribute = {};
                $.each(variation.attributes, (key, attribute) => {
                    firstAttribute[key] = attribute;
                    return false;
                })
                return JSON.stringify(firstAttribute);
            }
        },

        /**
         * Get the value from the first found attribute of the variation you want
         * @param  {object} variation Your chosen variation
         * @return {string}           the key of the first found variation
         */
        getAttributeString(variation) {
            return variation[Object.keys(variation)[0]];
        },

        /**
         * Get the studly key name form the currently chosen variation attribute
         * @return {string} The studly key
         */
        getAttributeKeyStringStudly() {
            return this.snakeToStudly(this.getAttributeKeyString());
        },

        /**
         * Get the actual usable name of the attribute as snake case
         * @return {[type]} [description]
         */
        getAttributeKeyString() {
            return this.variationAttributeKey.replace('attribute_', '')
        },

        /**
         * Find the sku of either a variation or when it doesn't have a variation
         * @param  {object} variation The variation you want to check on
         * @return {integer}           the sku
         */
        getSku(variation) {
            return (variation.sku) ? variation.sku : this.product.sku;
        },

        isInStock(variation) {
            if(variation) {
                return variation.is_in_stock;
            }
            return false;
        },

        // snake to camel case
        snakeToCamel(str) {
            return str.replace(/([-_]\w)/g, g => g[1].toUpperCase())
        },

        // snake to studly case
        snakeToStudly(str) {
            let name = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
            return name.charAt(0).toUpperCase() + name.slice(1);
        }
    },
    mounted() {
        // set a default
        this.resetVariation();

        // catch escape for closure
        $(document).keyup((event) => {
            if (event.key === "Escape") { // escape key maps to keycode `27`
                this.close();
            }
        });

        // Watch for the trigger that closes the cart so we can close our popup
        $(document.body).on('added_to_cart', () => {
            $('html, body').animate({
                scrollTop: $('.quick-buys').outerHeight()
            }, 1000);
            this.close();
        });

        new Swiper(this.$refs.carousel, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],
            // Optional parameters
            slidesPerView: 2,
            autoplay: false,
            pagination: false,
            enabled: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                767.98: {
                    slidesPerView: 1,

                },
            },
        })
    }
}
</script>